import React from 'react';
import PropTypes from 'prop-types';
import {
    UserContext,
    JoinContext,
    ExperimentContext,
    DOMUtilsContext,
    VrboHandler
} from '../../contexts';

function LYPContext({ children, history }) {
    return (
        <ExperimentContext history={history}>
            <UserContext history={history}>
                <JoinContext history={history}>
                    <VrboHandler history={history}>
                        <DOMUtilsContext history={history}>
                            {children}
                        </DOMUtilsContext>
                    </VrboHandler>
                </JoinContext>
            </UserContext>
        </ExperimentContext>
    );
}

LYPContext.propTypes = {
    children: PropTypes.node.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired
};
LYPContext.displayName = 'LYPContext';

export default LYPContext;
